import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import 'antd/dist/antd.min.css';

import Router from "./router";

const App = () => (
  <BrowserRouter>
    <Router />
  </BrowserRouter>
);

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(<App />);
}
